import { Component, OnInit, TemplateRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'; 
import { ToastrService } from 'ngx-toastr';
import { TipoSeguros } from 'src/app/api/module/portal/enumerable/tipo-seguro-enumerable';
import { AutoSliderItem } from 'src/app/api/module/portal/model/auto-slider';
import { AutoSliderImagesService } from 'src/app/api/module/portal/services/auto-slider-images.service';

@Component({
  selector: 'app-seguros',
  templateUrl: './seguros.component.html',
  styleUrls: ['./seguros.component.scss']
})
export class SegurosComponent implements OnInit {
  sliderItemsSeguro: AutoSliderItem[] = [];
  modalRef?: BsModalRef;
  urlIframe!: SafeResourceUrl;
  @BlockUI() public blockUI!: NgBlockUI;
  public tiposSeguros = TipoSeguros;
  urlFrame: string="";
  tituloSimulacao!: string;
  constructor(     private sanitizer: DomSanitizer,
    private modalService: BsModalService,     private toastr: ToastrService,
    private autoSliderImagesService: AutoSliderImagesService
    ) { }

  ngOnInit(): void {
    this.loadImagesSeguro();
  }

  loadImagesSeguro() { 
    this.autoSliderImagesService.getImagesSeguro().subscribe(images => {
        // triplicar os itens da lista
       this.sliderItemsSeguro = images.concat(images,images);
    });
  }
  
  cotacaoOnline(template: TemplateRef<any>, tipo: string) { 
    this.blockUI.start();  
     setTimeout(() => {  
      if (this.tiposSeguros.RESIDENCIAL == tipo) 
      {
        this.tituloSimulacao = 'SEGURO - ' + this.tiposSeguros.RESIDENCIAL

        this.urlFrame = `https://www.corretor-online.com.br/canalcliente/indexRes.htm?ParamWS=SFloQkNzSXdFQUIvc3plYkZBeWlzQWNQb1hnU0xENGdwaEVEYXpac0V2STREejdKTDFpZHl6RHplYjBwK3BDOHc4bWVqcERkSW83UlFHYXBqbkEwK2dlMDBweEV4dGxPMTh0NUJzL0VnbHU5TTNzTm9kUklqUGF2RVpvUVBtck41YUJVNzMzd0xCSXF5NFlUeFJUV2ZnNDNVUkNXdUY2OE95cmhDdz09`; 

        this.blockUI.stop(); 
        return this.retornaModal(template);

      }
      
      else if (this.tiposSeguros.AUTO == tipo)  
      {
        this.tituloSimulacao = 'SEGURO - ' + this.tiposSeguros.AUTO

        this.urlFrame = `https://www.corretor-online.com.br/canalcliente/index.htm?ParamWS=SFlnN0NnSXhFRUJ2TTUyYitFTVVwckFJaTVYZzRnRmlkc1RBdUJNbUNUbWNoVWZ5Q3E2KzV2SGU1L1htR0dnS0hudDNPa0x5bzNyQk5TVFI0aGxYOWdmVVhMMUd3Y0gxMTh0NWdDQXNpaHU3Mis0dFVDNlJCZDFmUzZqSytDZ2w1WU14cmJVdWlDb1YwWVZNSENlYSs5bmQxQUNOY2I1NDk1enBDdz09`; 
this.blockUI.stop(); 

        return this.retornaModal(template);

      }      
      else if (this.tiposSeguros.VIDA == tipo) 
      {
        this.urlFrame = `https://portal.geia.com.br/home/SeguroVida`;  
        this.blockUI.stop(); 
        this.tituloSimulacao = 'SEGURO - ' + this.tiposSeguros.VIDA

        return this.retornaModal(template);

      }
      else if (this.tiposSeguros.MOTO == tipo)  
      {
        this.tituloSimulacao = 'SEGURO ' + this.tiposSeguros.MOTO
        this.urlFrame = `https://www.corretor-online.com.br/canalcliente/index.htm?ParamWS=SFloQkNzSXdFQUIvc3plYkJCUlIySU9IVUhvU0xENGdwaEVEYXpac0V2STREejdKTDFpZHl6RHplYjBwK3BDOHc5Rk9KOGh1RWNkb0lMTlVSMmowRDJpbE9ZbU1zeDJ2bC9NTW5va0Z0M3EvTzJnSXBVWml0SDhaYUVMNHFEV1hvMUs5OThHelNLZ3NHMDRVVTFqN09keEVRVmppZXZIdXFJUXY=`; 
        this.blockUI.stop(); 

        return this.retornaModal(template);

      }      
      else if (this.tiposSeguros.VIAGEM == tipo) 
      {
        this.tituloSimulacao = 'SEGURO  - ' + this.tiposSeguros.VIAGEM
        this.urlFrame = `https://portal.geia.com.br/home/SeguroViagem`; 
        this.blockUI.stop(); 

        return this.retornaModal(template);
        

}      
      else if (this.tiposSeguros.CAMINHAO == tipo) 
      {
        this.tituloSimulacao = 'SEGURO  - ' + this.tiposSeguros.CAMINHAO
        this.urlFrame = `https://www.corretor-online.com.br/canalcliente/index.htm?ParamWS=SFlnN0NnSXhFRUJ2TTUyYitFTVVwckFJaTVYZzRnRmlkc1RBdUJNbUNUbWNoVWZ5Q3E2KzV2SGU1L1htR0dnS0hudDNPa0x5bzNyQkZTVFI0aG5YOWdmVVhMMUd3Y0gxMTh0NWdDQXNpaHU3Mis0dFVDNlJCZDFmUzZqSytDZ2w1WU14cmJVdWlDb1YwWVZNSENlYSs5bmQxQUNOY2I1NDk1enBDdz09`; 
        this.blockUI.stop(); 

        return this.retornaModal(template);
        

}      
      this.toastr.warning("EM DESENVOLVIMENTO")
this.blockUI.stop(); 

     }, 1000);
    

   } 

  private retornaModal(template: TemplateRef<any>) {
    this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlFrame);
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  decline(): void {
    this.modalRef?.hide();
  } 
}
